export const getActivities = async (welletContext, page = 1, pageSize = 10) => {
  try {
    const response = await welletContext.apis.tickets.get(
      '/associate/livefeed',
      {
        params: {
          page,
          pageSize
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching live feed:', error);
    throw error;
  }
}; 

export const fetchNetworkStats = async (welletContext) => {
  try {
    const response = await welletContext.apis.tickets.get('/associates/getnetworksummary',
      
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const getPayouts = async (welletContext, skip = 0, limit = 5) => {
  try {
    const response = await welletContext.apis.tickets.get('/associate/payouts', {
      params: { skip, limit },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

